import { Shield, Thermometer, Award, Map, Brain, Flame, Target, Search } from 'lucide-react'
import { cn } from '@/lib/utils'

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  shield: Shield,
  thermometer: Thermometer,
  award: Award,
  map: Map,
  brain: Brain,
  flame: Flame,
  target: Target,
  search: Search,
}

interface FeatureItem {
  icon: string
  title: string
  description: string
}

interface FeatureGridProps {
  heading: string
  items: FeatureItem[]
  className?: string
}

export function FeatureGrid({ heading, items, className }: FeatureGridProps) {
  return (
    <section className={cn('py-20 md:py-28 bg-[#F9F6F1] border-t-4 border-brand-red', className)}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl md:text-4xl font-bold text-brand-dark mb-12 text-center">
          {heading}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, index) => {
            const IconComponent = iconMap[item.icon]
            return (
              <div
                key={index}
                className="bg-white p-6 md:p-8 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300 text-center"
              >
                {IconComponent && (
                  <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-red/10">
                    <IconComponent className="h-7 w-7 text-brand-red" />
                  </div>
                )}
                <h3 className="text-lg font-bold text-brand-dark mb-3">
                  {item.title}
                </h3>
                <p className="text-brand-text leading-relaxed">
                  {item.description}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
